// This file was auto-generated by Fern from our API Definition.
export const RunOrigin = {
    Web: "web",
    Api: "api",
    Installation: "installation",
    Schedule: "schedule",
    Subscription: "subscription",
    Evaluation: "evaluation",
    Child: "child",
};
